export default __webpack_public_path__ + "static/media/customKitchen4CroppedRight.40253b77.jpeg";